/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/free-mode';

import { Suspense } from 'react';
import { Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { SectionDivider } from '~/components/SectionDividor';
import { OFFERS_ROUTER } from '~/constants/router';
import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import { useFrequentlyOrderProducts } from '~/domains/products/queries';
import { useLinkComponent } from '~/hooks/mobileApp';

import FrequentlyOrderedECouponProductCard from './FrequentlyOrderedECouponProductCard';
import FrequentlyOrderedProductCard from './FrequentlyOrderedProductCard';

import { MoreIcon } from '~/assets/icons';

function FrequentlyOrderedShowcaseContainer() {
  const LinkComponent = useLinkComponent();
  const { data } = useFrequentlyOrderProducts();

  if (!data?.length) return null;

  return (
    <>
      <div className="my-16">
        <div className="mb-16 flex items-center justify-between px-20">
          <h2 className="text-normal typo-title100-semibold">
            자주 구매한 상품
          </h2>
          <LinkComponent
            href={OFFERS_ROUTER.frequentlyOrdered}
            className="ml-8 shrink-0"
          >
            <span className="flex items-center text-blue-800 typo-paragraph100-regular">
              전체보기
              <MoreIcon />
            </span>
          </LinkComponent>
        </div>

        <div>
          <Swiper modules={[Lazy]} slidesPerView="auto" lazy>
            {(data || []).slice(0, 10).map((product) => {
              return (
                <SwiperSlide
                  key={product.offerId}
                  className="ml-16 !h-auto !w-[140px] first-of-type:ml-20 last-of-type:mr-20"
                >
                  {product.productType === PRODUCT_TYPE_E_COUPON ? (
                    <FrequentlyOrderedECouponProductCard data={product} />
                  ) : (
                    <FrequentlyOrderedProductCard data={product} />
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
      <SectionDivider />
    </>
  );
}

export function FrequentlyOrderedShowcase() {
  return (
    <Suspense fallback={<></>}>
      <FrequentlyOrderedShowcaseContainer />
    </Suspense>
  );
}
